export default __webpack_public_path__ + "static/media/icn-delete.5cd68fb4.svg";